import Vue from 'vue'
import Vuex from 'vuex'
import notifications from '../store/modules/notifications'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isMenuVisible: false,
        Userpermission: false,
        companyObj: {},
        userObj: {},
        UserName: '',
        companyName: '',
        compayLogo: ''
    },
    actions:{
        Logar({commit}){
            commit("logar");
        },
        Sair({commit}){
            commit("sair");
        },
        Permission({commit}){
            commit("permission")
        },
        SetUserName({commit}){
            commit("setusername")
        },
        SetCompany({commit}){
            commit("setcompany")
        },
        SetUser({commit}){
            commit("setuser")
        }
    },
    mutations: {
        logar(state) {  
            if(sessionStorage.getItem('accToken') != null)                                  
            state.isMenuVisible = true           
        },
        sair(state){
            sessionStorage.clear()
            state.isMenuVisible = false 
            state.Userpermission = false
        },
        permission(state){
            if(sessionStorage.getItem('userPermission') == 'ADMIN' || sessionStorage.getItem('userPermission') == 'GERENTE'){
            state.Userpermission = true 
            }                 
        },
        setusername(state){
            if(sessionStorage.getItem('userName') != null)
            state.UserName = sessionStorage.getItem('userName') 
        },
        setcompany(state){
            if(sessionStorage.getItem('company'))
            state.companyObj = JSON.parse(sessionStorage.getItem('company'))
        },
        setuser(state){
            if(sessionStorage.getItem('user') != null)
            state.userObj = JSON.parse(sessionStorage.getItem('user'))
        }
    },
    modules:{
        notifications
    }
})